import React from "react";
import { useRef, useEffect } from "react";

const CardCarousel = (props) => {

    const autoScrollSpeed = props.speed; // pixel per second
    const autoScrollEnabled = useRef(true);
    const autoScrollSubpixel = useRef(0)
    const lastTimestamp = useRef(0);
    const animationFrame = useRef(null);

    const leftRef = useRef(null);
    const middleRef = useRef(null);
    const rightRef= useRef(null);
    const parentRef = useRef(null);

    const dragStart = useRef(0);
    const isDragging = useRef(false);
    const scrollAtStart = useRef(0);

    useEffect(() => {
        parentRef.current.scrollLeft = middleRef.current.offsetLeft;
        autoScroll();
        return () => {
            cancelAnimationFrame(animationFrame.current);
        }
    }, [])
    
    function handleDragStart(event) {
        event.preventDefault();
        isDragging.current = true;
        dragStart.current = event.clientX || event.touches[0].clientX;
        scrollAtStart.current = parentRef.current.scrollLeft;
    }

    function handleDragEnd(event) {
        event.preventDefault();
        if (!isDragging.current) return;
        isDragging.current = false;
    }

    function handleDragMove(event) {
        event.preventDefault();
        if (!isDragging.current) return;
        const mousePos = event.clientX || event.touches[0].clientX;
        if (!mousePos) return;
        parentRef.current.scrollLeft = scrollAtStart.current - (mousePos - dragStart.current)

    }

    function handleLoop() {
        const jump = {
            from: parentRef.current.scrollLeft
        }
        if (parentRef.current.scrollLeft <= 0) {
            jump.to = getRelativeDistance(middleRef.current)
        } else if (parentRef.current.scrollLeft >= getRelativeDistance(rightRef.current, true) - parentRef.current.offsetWidth) {
            jump.to = jump.from - rightRef.current.offsetWidth - getGap();
        } else {
            return;
        }
        parentRef.current.scrollLeft = jump.to;
        jump.distance = jump.to - jump.from;
        scrollAtStart.current += jump.distance;
    }

    function getRelativeDistance(element, rightEdge=false) {
        return element.offsetLeft - leftRef.current.offsetLeft + (rightEdge ? element.offsetWidth : 0)
    }

    function getGap() {
        console.log(parseInt(getComputedStyle(parentRef.current).gap))
        return parseInt(getComputedStyle(parentRef.current).gap)
    }

    function autoScroll(timestamp) {
        handleLoop();
        // requestAnimationFrame callback function accepts a timestamp parameter!
        if (lastTimestamp.current) {
            const delta = (timestamp - lastTimestamp.current) / 1000;
            const distance = autoScrollSpeed * delta;
            
            autoScrollSubpixel.current += distance;
            const wholePixels = Math.floor(autoScrollSubpixel.current);
            autoScrollSubpixel.current -= wholePixels;
            
            parentRef.current.scrollLeft += wholePixels;
        }
        if (autoScrollEnabled.current) {
            lastTimestamp.current = timestamp
            animationFrame.current = requestAnimationFrame(autoScroll);
        }
    }

    return (
        <div className="carousel" 
            onTouchStart={handleDragStart} 
            onTouchEnd={handleDragEnd} 
            onTouchMove={handleDragMove} 
            onMouseDown={handleDragStart}
            onMouseUp={handleDragEnd} 
            onMouseLeave={handleDragEnd}
            onMouseMove={handleDragMove} 
            ref={parentRef}
        >
            <div className="card-display" ref={leftRef}>
                { props.children }
            </div>
            <div className="card-display" ref={middleRef}>
                { props.children }
            </div>
            <div className="card-display" ref={rightRef}>
                { props.children }
            </div>
        </div>
    )
}

CardCarousel.defaultProps = {
    speed: 50,
}

export default CardCarousel